import React, {useState} from 'react';
import {Drawer} from "antd";
import {PlusOutlined} from '@ant-design/icons';

import './styles.scss';
import Button from "../../common/Button/Button";
import ClientForm from "./ClientForm";

interface Props {
    className?: string,
    onSubmit?: (values: string) => void,
}

function ClientFormModalAsButton(props: Props) {
    const {className, onSubmit} = props;
    const [showForm, setShowForm] = useState(false);

    const onButtonClick = async (e: any) => {
        e.stopPropagation();
        setShowForm(true);
    }

    const onFormSubmit = async (values: any) => {
        if (onSubmit) await onSubmit(values);
        setShowForm(false);
    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <Button icon={<PlusOutlined/>} className={className} onClick={onButtonClick}>
                Create Client
            </Button>
            <Drawer title='Create Client' width='50%' keyboard={false} open={showForm} destroyOnClose
                    onClose={() => setShowForm(false)}
                    className='clients-form-drawer' footer={null}>
                <ClientForm applyDrawerStyles onSubmit={onFormSubmit}/>
            </Drawer>
        </div>
    )
}

export default ClientFormModalAsButton;